module.exports = __webpack_public_path__ + "img/register.bacd3118.svg";